<template>
    <div
        tabindex="0"
        ref="select"
        class="select-box"
        :class="{ disabled: disabled }"
        @click="openTextOptions()"
    >
        <div class="tipos-box-tipo">
            <svg class="svg-icons" v-if="icons">
                <use
                    :xlink:href="require('@/assets/img/icons/' + getSVG() + '.svg') + '#layer'"
                ></use>
            </svg>
            <input
                class="tipos-box-desc"
                :value="value"
                :placeholder="placeholder"
                :readonly="editable" 
            />
            <!-- <div class="tipos-box-desc" :value="value == '' ? getItem() : value" @change="updateValue" v-else /> -->
            <svg class="svg-icons arrow-down">
                <use :xlink:href="require('@/assets/img/icons/menu-down.svg') + '#layer'"></use>
            </svg>
        </div>
        <div class="tipos-box" v-if="optmenu" @click.stop>
            <div
                class="tipos-box-tipo"
                v-for="(item, i) in itens"
                :key="i"
                :desc="item.desc"
                @click="setSelectedItem(i)"
                :class="{ selected: selectedIndex == i }"
            >
                <svg class="svg-icons" v-if="icons">
                    <use
                        :xlink:href="require('@/assets/img/icons/' + item.svg + '.svg') + '#layer'"
                    ></use>
                </svg>
                <div class="tipos-box-desc">{{ getDescription(item) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        icons: {
            default: 'false',
        },
        items: Array,
        placeholder: {
            default: 'Selecione o item',
        },
        editable: {
            default: false,
        },
        disabled: {
            default: false,
        },
        model: {
            default: '',
        },
        listOnClick: Function,
        onUpdate: Function,
    },
    data() {
        return {
            selectedIndex: -1,
            itemsnum: 0,
            optmenu: false,
            selected: false,
            value: '',
            itens: [],
        };
    },
    created() {
        this.itemsnum = this.itens.length;
        //   this.value = this.getItem();
    },
    mounted() {
        let select = this.$refs['select'];
        this.itens = this.items;
        setTimeout(() => {
            this.updateModel();
        }, 1000);
    },
    methods: {
        openTextOptions() {
            if (!this.itens) {
                this.itens = this.listOnClick();
            }
            if (!this.disabled && this.itemsnum > 0) {
                this.selected = false;
                this.optmenu = true;
            }
        },
        setSelectedItem(index) {
            this.selected = true;
            this.selectedIndex = index;
            this.value = this.getItem();
            setTimeout(() => {
                this.optmenu = false;
            }, 100);
        },
        getSVG() {
            if (this.selectedIndex >= 0 && this.itens[this.selectedIndex].svg.length > 0) {
                return this.itens[this.selectedIndex].svg;
            } else {
                return 'text-short';
            }
        },
        updateModel() {
            if (this.model != null && this.model != undefined) {
                let value = this.itens.filter((i) => {
                    return JSON.stringify(i.value) == JSON.stringify(this.model);
                })[0];
                if (value) {
                    this.value = value.desc;
                }
            }
        },
        getItem() {
            if (this.selectedIndex >= 0) {
                let item = this.itens[this.selectedIndex];
                this.onUpdate(item.value);
                return this.getDescription(item);
            } else if (!this.editable) {
                return '';
            }
        },
        getDescription(item) {
            if (!item) {
                return '';
            }

            if (typeof item == 'string') {
                return item;
            }
            return item.desc;
        },
        updateValue() {
            this.$emit('input', getItem());
        },
    },
};
</script>

<style lang="scss" scoped>
.novos-campos .select-box {
    background-color: $darker-bg-color;
    border-radius: 5px;
    padding: 8px;
    width: 100%;
    position: relative;
    outline: none;

    > .tipos-box-tipo {
        justify-content: space-between;
    }
    > .tipos-box-tipo input,
    > .tipos-box-tipo i {
        font-size: 18px;
        margin-left: 0;
        margin-right: 0;
    }

    .tipos-box {
        position: absolute;
        top: -120px;
        right: -2px;
        background: $sovis-white;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        z-index: 1000;
        .tipos-box-tipo {
            padding: 15px 15px 15px 15px;

            > svg {
                margin-left: 18px;
                margin-right: 39px;
            }
        }
        .tipos-box-tipo:hover {
            background: $darker-bg-color;
        }
    }
    .tipos-box-tipo {
        display: flex;
        position: relative;
        cursor: pointer;
        > svg {
            font-size: 20px;
            fill: $light-gray-color;
            cursor: pointer;
            top: 50%;
            position: absolute;
            transform: translateY(-50%);
            right: 0;
        }
        > svg.arrow-down {
            margin-right: 0;
            width: 25px;
            height: 25px;
        }
        input,
        div {
            font-size: 20px;
            color: $darker-gray-color;
            padding-left: 20px;
            cursor: pointer;
        }
        &.selected {
            background-color: $darker-bg-color;
        }
        &:nth-child(7),
        &:nth-child(9),
        &:nth-child(11) {
            border-bottom: 0.5px solid $light-gray-color;
        }
    }
}

.select-box {
    background-color: $sovis-white;
    border-radius: 5px;
    padding: 4px;
    width: 100%;
    border: 1px solid #dddddd;
    color: $light-gray-color;
    position: relative;

    &.disabled {
        background: #e3e3e3;
    }

    > .tipos-box-tipo {
        justify-content: space-between;
    }
    > .tipos-box-tipo input,
    > .tipos-box-tipo i {
        font-size: 14px;
        margin-left: 0;
        margin-right: 0;
        border: none;
        padding: 0;
        background: transparent;
        flex: 1 1 auto;
    }

    .tipos-box {
        position: absolute;
        top: 0;
        right: 0;
        background: $sovis-white;
        box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        z-index: 1000;
        width: 95%;

        .tipos-box-tipo {
            padding: 15px 15px 15px 15px;
        }
        .tipos-box-tipo:hover {
            background: $darker-bg-color;
        }
    }
    .tipos-box-tipo {
        display: flex;
        cursor: pointer;
        position: relative;
        > svg {
            top: 50%;
            position: absolute;
            transform: translateY(-50%);
            font-size: 20px;
            fill: $light-gray-color;
            cursor: pointer;
            right: 0;
        }
        > svg.arrow-down {
            margin-right: 0;
            width: 25px;
            height: 25px;
        }
        div,
        input {
            font-size: 16px;
            line-height: 17px;
            padding-top: 6px;
            padding-left: 20px;
            color: $darker-gray-color;
            cursor: pointer;
            outline: none !important;
        }
        &.selected {
            background-color: $darker-bg-color;
        }
        &:nth-child(7),
        &:nth-child(9),
        &:nth-child(11) {
            border-bottom: 0.5px solid $light-gray-color;
        }
    }
}
</style>
